import { ToString } from 'src/lib/fliko/helpers/toString.helper';
import { ResidentType } from 'src/lib/fliko/models/person/resident.data';
import { UserPRSList } from '../services/models/users-table.data';
import { UnitResidentViewModel } from '../services/models/users-view-models';

export class ResidentsListBuilder {
  public static forPRS(data: UserPRSList.RentalUnitElement | UserPRSList.AgreementElement): UnitResidentViewModel[] {
    const landlords = data.landlords.map((landlord) => {
      return {
        id: landlord.id,
        name: ToString.fullName(landlord),
        type: ResidentType.LANDLORD
      };
    });
    const tenants = data.tenants.map((tenant) => {
      return {
        id: tenant.id,
        name: ToString.fullName(tenant),
        type: ResidentType.TENANT
      };
    });
    return landlords.concat(tenants);
  }
}
